import { AttachmentEntityInterface, UserEntityInterface } from '@types';
import { answerAttachments } from '@images/questionnaire/questionnaireImages';
import { LangEnum } from '@enums';

export type AnswerEnvironmentState = {
  context: any;
  questionnaireContext: any;
  owner: UserEntityInterface;
  isDownload: boolean;
  userAbbr: string;
  attachments: AttachmentEntityInterface[];
  lang: LangEnum;
};

export const answerEnvironmentInitialState: AnswerEnvironmentState = {
  context: null,
  questionnaireContext: null,
  owner: null,
  isDownload: false,
  userAbbr: null,
  attachments: answerAttachments,
  lang: LangEnum.ENG,
};
